module.exports = __webpack_public_path__ + "img/22.a30ce713.png";